import { InjectionToken } from "@angular/core";
import { AWSCloudWatchClientConfig, AWSCloudWatchStreamConfig } from "./aws-config.model";

export const AWS_STREAM_CONFIG = new InjectionToken<AWSCloudWatchStreamConfig>('AWSCloudWatchStreamConfig')
export const AWS_CLOUD_WATCH_CLIENT_CONFIG = new InjectionToken<AWSCloudWatchClientConfig>('AWSCloudWatchClientConfig')
